<template>
  <div id="Error" class="kt-quick-panel--right kt-demo-panel--right kt-offcanvas-panel--right kt-header--fixed kt-header-mobile--fixed kt-subheader--fixed kt-subheader--enabled kt-subheader--solid kt-aside--enabled kt-aside--fixed kt-page--loading">
		<!-- begin:: Page -->
		<div class="kt-grid kt-grid--ver kt-grid--root">
			<div class="kt-grid__item kt-grid__item--fluid kt-grid  kt-error-v5" :style="{ 'height': window.height + 'px' }" style="background-image: url(static/assets/media//error/bg5.jpg);">
				<div class="kt-error_container">
					<span class="kt-error_title">
						<h1>Oops!</h1>
					</span>
					<p class="kt-error_subtitle">
						Something went wrong here.
					</p>
					<p class="kt-error_description">
						We're working on it and we'll get it fixed<br>
						as soon possible.<br>
						You can back or use our Help Center.<br>
                        <button @click="$router.push('/')" class="btn-lg btn-primary mt-3"><i class="fa fa-home" aria-hidden="true"></i> Go To Main Page</button>
					</p>
				</div>
			</div>
		</div>
		<!-- end:: Page -->
  </div>
</template>

<script>
import '../../static/assets/css/pages/general/error/error-5.css'
export default {
  data () {
    return {
      window: {
        width: 0,
        height: 0
      }
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize () {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Error_page.vue